import * as tslib_1 from "tslib";
import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return MaintenanceTypeComponent; }),
    multi: true
};
var MaintenanceTypeComponent = /** @class */ (function () {
    function MaintenanceTypeComponent(fuseTranslationLoaderService) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.maintenanceTypes = [];
        this.disabled = false;
        this.required = true;
        this.appearance = 'legacy';
        this.fromControl = new FormControl(null, [Validators.required]);
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.fromControl.valueChanges
            .pipe(debounceTime(500))
            .subscribe(function (value) {
            _this.onChange(value);
        });
    }
    MaintenanceTypeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.disabled ? this.fromControl.disable() : this.fromControl.enable();
                return [2 /*return*/];
            });
        });
    };
    MaintenanceTypeComponent.prototype.writeValue = function (maintenanceTypeId) {
        this.fromControl.setValue(maintenanceTypeId);
    };
    MaintenanceTypeComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    MaintenanceTypeComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return MaintenanceTypeComponent;
}());
export { MaintenanceTypeComponent };
